import React from 'react'
import { Button, ButtonGroup } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux';
import { ModalMovActions } from '../../presentation/redux/actions/ModalMovActions';
import { RootState } from '../../presentation/redux/store/RootState';
import { ButtonDownloadExcelComponent } from '../csv/ButtonDownloadExcelComponent';
import { sellDataToCsv } from './sellDataToCsv';
import PropTypes from 'prop-types';

export const ModalMovActionButtons = ({ inverted = false }: any) => {

    const dispatch = useDispatch();

    const modalState = useSelector((s: RootState) => s.modalMovState);
    const handleBack = () => {
        dispatch(ModalMovActions.open({
            ...modalState,
            page: modalState.page - 1
        }));
    }

    const handleNext = () => {
        dispatch(ModalMovActions.open({
            ...modalState,
            page: modalState.page + 1
        }));
    }


    return inverted ? (
        <div className="d-flex flex-row col-12 justify-content-between mb-2 mt-2">
            <div className=" float-left align-self-end">
                <div className="btn btnPrimary btn-transparent" onClick={(_) => {
                    dispatch(ModalMovActions.setPage(0));
                    dispatch(ModalMovActions.setCustom(true))
                }}>Personalizar</div>
            </div>

            <div className="float-right d-flex flex-column">


                <ButtonGroup aria-label="Paginate">
                    <Button disabled={modalState.page === 0} onClick={handleBack} variant="light">Anterior</Button>
                    <b className="m-2 text-center align-self-center">{`Pag. ${modalState.page + 1}`}</b>
                    <Button disabled={modalState.data && modalState.data.length < 50} onClick={handleNext} variant="light">Siguiente</Button>
                </ButtonGroup>

                <div className='align-self-end mt-4'>
                    {
                        modalState.dataAll.length > 0 &&
                        <ButtonDownloadExcelComponent
                            className='btnPrimary bgPrimary'
                            csvData={sellDataToCsv(modalState.dataAll, modalState.isResume)}
                            fileName={modalState.isResume ? 'ResumenDelDia.csv' : 'Historico.csv'} />
                    }
                </div>

            </div>
        </div>
    ) : (
        <div className="d-flex flex-row col-12 justify-content-between mb-2 mt-2">
            <div className=" float-left">
                <div className="btn btnPrimary btn-transparent" onClick={(_) => {
                    dispatch(ModalMovActions.setPage(0));
                    dispatch(ModalMovActions.setCustom(true))
                }}>Personalizar</div>
            </div>

            <div className="float-right d-flex flex-column">
                <div className='align-self-end'>
                    <ButtonDownloadExcelComponent
                        className='btnPrimary bgPrimary'
                        csvData={sellDataToCsv(modalState.dataAll, modalState.isResume)}
                        fileName={modalState.isResume ? 'ResumenDelDia.csv' : 'Historico.csv'} />
                </div>


                <ButtonGroup aria-label="Paginate" className="mt-4">
                    <Button disabled={modalState.page === 0} onClick={handleBack} variant="light">Anterior</Button>
                    <b className="m-2 text-center align-self-center">{`Pag. ${modalState.page + 1}`}</b>
                    <Button disabled={modalState.data && modalState.data.length < 50} onClick={handleNext} variant="light">Siguiente</Button>
                </ButtonGroup>
            </div>
        </div>
    )
}

ModalMovActionButtons.propTypes = {
    inverted: PropTypes.bool
}